interface CupIconProps extends React.HTMLAttributes<HTMLSpanElement> {
  size?: number;
  fillColor?: string;
}

export default function CupIcon({
  size = 36,
  className = '',
  fillColor = '#FFC975',
  onClick = (event) => {},
  ...props
}: CupIconProps) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick} {...props}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M19.4252 2.32263C19.4998 1.54892 19.4998 0.852127 19.4998 0H4.50016C4.50016 0.852127 4.50016 1.54892 4.5747 2.32263H0V3.09635C0 9.98732 8.47581 14.8648 10.5009 15.9478L10.4995 18.581C10.4995 19.8977 9.52492 20.9037 8.24939 20.9037H6.74885V24H17.2497V20.9037H15.7492C14.4737 20.9037 13.4991 19.8977 13.4991 18.581V15.9492C15.5242 14.8648 24 9.98728 24 3.0978V2.32408L19.4252 2.32263ZM1.57504 3.87155H4.72516C5.0247 7.3555 5.8502 9.83347 6.75024 11.6132C4.34967 9.67813 1.87457 6.9679 1.57504 3.87155ZM17.3256 11.6132C18.2257 9.83198 19.0512 7.3555 19.3507 3.87155H22.5008C22.1254 6.9679 19.6503 9.67813 17.3256 11.6132Z'
          fill={fillColor}
        />
      </svg>
    </span>
  );
}
